import LinkToDocusaurus from '../LinkToDocusaurus'
import { testManagementToolIntegration } from '../../docs-routes'

const LinkToTestManagementToolsDoc = () =>
  <LinkToDocusaurus path={testManagementToolIntegration}>
    Learn more about Test Management Tools
  </LinkToDocusaurus>

export default LinkToTestManagementToolsDoc
